import { HomePage } from "@/pages/HomePage.js";
import { PostPage, PostsPage } from "@/pages/PostsPage.js";
import { WinnersPage } from "@/pages/WinnersPage.js";
import { Layout } from "./Layout.js";
import { RouterProvider, useRouter } from "./router.js";

export function App() {
  return (
    <RouterProvider>
      <Layout>
        <Pages />
      </Layout>
    </RouterProvider>
  );
}

function Pages() {
  const { route } = useRouter();

  switch (route.name) {
    case "posts":
      return <PostsPage />;
    case "post":
      return <PostPage slug={route.slug} />;
    case "winners":
      return <WinnersPage />;
    default:
      return <HomePage />;
  }
}
